import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { orderBy, where } from 'firebase/firestore';
import {
  CollectionName,
  FunctionName,
} from '@verify/shared-components/helpers';
import {
  AssetMatch,
  DownloadMatchesRequest,
  DownloadMatchesResponse,
} from '@verify/shared-components/models';
import {
  FirestoreService,
  FunctionService,
  StorageService,
} from '@verify/shared-components/services';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssetMatchService {
  private firestore = inject(FirestoreService);
  private functionService = inject(FunctionService);
  private storageService = inject(StorageService);

  exporting: WritableSignal<boolean> = signal(false);

  constructor() {}

  getAssetMatches(assetId?: string): Observable<AssetMatch[]> {
    return this.firestore.getQuery<AssetMatch>(
      CollectionName.assetMatches,
      ...(assetId ? [where('assetId', '==', assetId)] : []),
      orderBy('creationDate', 'desc'),
    );
  }

  exportMatches(request?: {
    projectId?: string;
    collectionId?: string;
  }): Observable<DownloadMatchesResponse> {
    if (this.exporting()) {
      return of(null);
    }

    this.exporting.set(true);
    const response = this.functionService.call<
      DownloadMatchesRequest,
      DownloadMatchesResponse
    >(FunctionName.downloadMatches, request || {}, { timeout: 600000 });

    response.subscribe((response) => {
      this.storageService
        .getDownloadUrlFromPath(response.downloadUrl)
        .subscribe((url) => {
          this.exporting.set(false);
          window.open(url);
        });
    });
    return response;
  }
}
